import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import EnumSelect from 'components/field/EnumSelect';
import StringInput from 'components/field/StringInput';
import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import { updateDynamicListData } from 'components/list/dynamicListSlice';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { ENUMS, FINANCE } from 'services/consts';

import AppLogger from 'utils/AppLogger';
import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const UpdateCODStatusModal = NiceModal.create(({ IDs, status }) => {
	const modal = useModal();
	const dispatch = useDispatch();
	const axios = useAxiosPrivate();
	const { showError, showSuccess } = useAlert();

	const [isLoading, setIsLoading] = useState(false);

	const schema = useMemo(
		() =>
			yup.object().shape({
				description: yup.string().nullable().required()
			}),
		[]
	);

	const formMethods = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			description: null,
			IDs
		}
	});

	const { setValue, handleSubmit, watch } = formMethods;

	useEffect(() => {
		let CODWalletTransactionID = '';
		IDs.forEach((orderID, index) => {
			CODWalletTransactionID += orderID + (index !== IDs.length - 1 ? ', ' : '');
		});
		setValue('CODWalletTransactionID', CODWalletTransactionID);
	}, [IDs]);

	const onSubmit = async (data) => {
		setIsLoading(true);

		try {
			const response = await axios.post(FINANCE.UPDATE_COD_WALLET_TRANSACTION_DESCRIPTION, {
				IDs,
				description: data.description
			});
			if (response.status === 200) {
				if (status === 'failed') dispatch(updateDynamicListData(DYNAMICLISTS.BANK_TRANSFER_FAILED));

				showSuccess();
			}
		} catch (error) {
			AppLogger.error(error);
			showError();
		} finally {
			setIsLoading(false);
			modal.remove();
		}
	};

	return (
		<Modal maxWidth="x-small" fullwidth className="modal-updateCODStatusModal">
			<ModalTitle>
				<Typography variant="p1">{`${status}.updateCODStatusModalTitle`}</Typography>
			</ModalTitle>
			<ModalContent>
				<Form formMethods={formMethods}>
					<FormItem label="CODWalletTransactionID">
						<StringInput name="CODWalletTransactionID" disabled={true} />
					</FormItem>

					<FormItem label="description" isLoading={isLoading}>
						<EnumSelect
							searchable={false}
							valueRemovable={false}
							enumName={ENUMS.COD_DESCRIPTIONS}
							name="description"
							value={watch(`description`)}
							setValue={(value) => {
								setValue(`description`, value, {
									shouldValidate: true,
									shouldDirty: true
								});
							}}
						/>
					</FormItem>
				</Form>
			</ModalContent>
			<ModalActions>
				<Button
					label="cancel"
					variant="outline"
					onClick={() => {
						modal.remove();
					}}
				/>

				<Button
					onClick={handleSubmit(onSubmit, (errors) => {
						AppLogger.log(errors);
					})}
					label="save"
					loading={isLoading}
					variant="blue"
				/>
			</ModalActions>
		</Modal>
	);
});

export default UpdateCODStatusModal;
